import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { loginAdmin } from '../services/service';
import { SET_USER } from '../store/slice';

export const LoginPage: React.FC = () => {
  const dispatch = useDispatch();

  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const login = async () => {
    setLoading(true);
    try {
      const r = await loginAdmin(name, password);

      if (r.result) {
        dispatch(SET_USER({ name, token: r.token }));
        setError('');
      } else {
        setError('Mauvais login ou mot de passe.');
      }
    } catch {
      setError('Une erreur est survenue.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-shell">
      <div className="login-panel">
        <div className="login-header">
          <span className="badge">Backoffice</span>
          <h1>HopLa Supervisor</h1>
          <p>Pilotage operationnel, clair et instantane.</p>
        </div>

        <div className="login-form">
          <label htmlFor="name">Nom</label>
          <input id="name" value={name} onChange={(e) => setName(e.target.value)} placeholder="admin" />

          <label htmlFor="password">Mot de passe</label>
          <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="��������" />

          <button className="primary-btn" onClick={login} disabled={loading}>
            {loading ? 'Connexion...' : 'Connexion'}
          </button>

          <div className="error-line">{error}</div>
        </div>
      </div>
    </div>
  );
};
